import { createSlice } from "@reduxjs/toolkit";
import { extraReducers } from "./action";

const initialState = {
  item: [],
  loadingStatus: "loaded",
};

const ipSlice = createSlice({
  name: "ip",
  initialState,
  reducers: {},
  extraReducers: extraReducers,
});

const { reducer } = ipSlice;

export default reducer;
